/* eslint-disable no-param-reassign */
import { BaseSchemaProcessor } from './base-schema-processor';

export class SelCustomerLevelAssociationsGridSchemaProcessor extends BaseSchemaProcessor {
  updateEntitySchemaForFeatures(entitySchema) {
    // Hide filterable fields that are in the entitySchema but not in this grid.
    const sharedEntityNameProperty = entitySchema.properties.SharedEntityName;
    const listItemCountProperty = entitySchema.properties.ListItemCount;
    const sharedEntityCustomerIdProperty = entitySchema.properties.SharedEntityCustomerId;
    const sharedEntityCustomerNameProperty = entitySchema.properties.SharedEntityCustomerName;

    if (sharedEntityNameProperty) {
      sharedEntityNameProperty.filterable = false;
    }

    if (listItemCountProperty) {
      listItemCountProperty.filterable = false;
    }

    if (sharedEntityCustomerIdProperty) {
      sharedEntityCustomerIdProperty.filterable = false;
    }

    if (sharedEntityCustomerNameProperty) {
      sharedEntityCustomerNameProperty.filterable = false;
    }

    return entitySchema;
  }
}
